import { Component } from '@angular/core';

@Component({
  selector: 'app-shubhneel-industries',
  templateUrl: './shubhneel-industries.component.html',
  styleUrls: ['./shubhneel-industries.component.scss']
})
export class ShubhneelIndustriesComponent {

}
